import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar-heading mb-0" }
const _hoisted_2 = { class: "navbar-nav" }

import { SidebarHeader } from "@/@types/dtos/sidebar.types";
import usePermission from "@/app/composables/usePermission";
import SidebarPathItem from "./SidebarPathITem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarHeaderITem',
  props: {
    header: {}
  },
  setup(__props: any) {

const props = __props;

const { userHasPermission } = usePermission();
const shouldShowHeader = props.header.paths.some((path) =>
  userHasPermission(path.permission)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.header.header && _unref(shouldShowHeader))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "navbar-divider" }, null, -1)),
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_ctx.header.header), 1)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.header.paths, (path, index) => {
        return (_openBlock(), _createBlock(SidebarPathItem, {
          path: path,
          key: index,
          showItem: _unref(userHasPermission)(path.permission)
        }, null, 8, ["path", "showItem"]))
      }), 128))
    ])
  ], 64))
}
}

})